const pathRoute = {
    // path: `http://localhost:8000`
    // path: `http://172.176.145.53/inventory`
    path: `https://sisinvserver.lavoroperu.pe/inventory`
}

export { pathRoute };